import React from 'react';
import { View, Text, FlatList, RefreshControl } from 'react-native';
import { connect } from 'react-redux';

import { fetchCompletedJourneys } from "../../redux/actions";

import Colors from "../../constants/Colors";
import {Card, CardTextArrow, Icon} from "../../components";
import JourneyInProgressComponent from "./components/JourneyInProgressComponent";
import NavBar from "../../components/NavBar";

class JourneyCompletedScreen extends React.Component {

    render() {
        return (
            <NavBar title={"Treinamentos Completos"} >

                {
                    (this.props.userCompletedJourneys.length === 0 && this.props.fetchingCompletedJourneys === false) &&
                    <CardTextArrow
                        text={"Ver novos treinamentos"}
                        showArrow={true}
                        onPress={() => this.props.history.push('/journeys/new')}
                        containerStyle={{ margin: 20 }}
                    >
                        <Text style={{ color: 'white', fontSize: 14, marginTop: 12 }}>
                            {
                                'Você ainda não completou nenhum treinamento, clique para ver todos os treinamentos que temos disponíveis para você.'
                            }
                        </Text>
                    </CardTextArrow>

                }

                <FlatList
                    data={this.props.userCompletedJourneys}
                    renderItem={({item}) => {
                        return <JourneyInProgressComponent data={item} />
                    }}
                    keyExtractor={item => item.PK.toString()}
                    refreshControl={
                        <RefreshControl
                            refreshing={this.props.fetchingCompletedJourneys}
                            onRefresh={() => this.props.fetchCompletedJourneys()}
                            colors={[Colors.spinnerColor]}
                            title={'Carregando jornadas completas!'}
                        />
                    }
                />

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        userCompletedJourneys: state.journey.userCompletedJourneys,
        fetchingCompletedJourneys: state.journey.fetchingCompletedJourneys,
    }
}

export default connect(mapStateToProps, { fetchCompletedJourneys })(JourneyCompletedScreen);
